export const TABS = {
  START: "/start",
  WELCOME: "/start/welcome",
  SESSION: "/start/session",
  RECEIPT: "/start/receipt",
  DASHBOARD: "/dashboard",
  ACTIVITY: "/here",
};
